<template>
  <div id="app">
    <v-app>
      <router-view />
    </v-app>
  </div>
</template>


<script>

export default {
  name: 'App',
  data () {    
    return {
      authenticated: false,
      pagingEnabled: false,

      opts: {
        start: 0,
        dir: 'v',
        duration: 100,
        overflow: 'auto',
        beforeChange: this.allowPaging,
        afterChange: this.afterPageChanged
      },

      drawer: true,
      fixed: false,
      items: [{
        icon: 'bubble_chart',
        title: 'Inspire'
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Vuetify.js'
    }
  },

  computed: {
  },

  created: function() {
    this.isAuthenticated()
  },

  mounted: function () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },

  watch: {
    '$route': 'isAuthenticated'
  },

  methods:{
    async isAuthenticated() {
      this.authenticated = await this.$auth.isAuthenticated()
    },

    login() {
      this.$auth.loginRedirect('/')
    },

    async logout () {
      await this.$auth.logout()
      await this.isAuthenticated()
    },

    fullpageController() {
//      return this.$refs.fullpage.$fullpage
    },
    handleResize() {
//      this.$refs.fullpage.$fullpage.resize()
    },

    allowPaging() {
      return this.pagingEnabled
    },
    afterPageChanged() { 
      this.pagingEnabled = false 
    }
  },
  components: {
  }
}
</script>

<style scoped>
.fullpage-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.page {
  color: #eee;
  font-family: Roboto, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.intro-page {
  text-align: center;
  background-color: #A2B3CE;
}

.app-page {
  background-color: #EEEEEE;
}

</style>
